(function () {
    function formatMoney(cents, currency, symbol) {
        if (typeof cents !== 'number' || Number.isNaN(cents)) return '—';
        var amount = cents / 100;
        try {
            return new Intl.NumberFormat(undefined, { style: 'currency', currency: currency || 'USD' }).format(amount);
        } catch (e) {
            return (symbol || '') + amount.toFixed(2);
        }
    }

    function getCardWrapper(checkbox) {
        return checkbox.closest('.product-card-wrapper--index-toys');
    }

    function syncCheckedBorder(card) {
        if (!card || !card.classList.contains('product-card-wrapper--index-toys')) return;
        var cb = card.querySelector('[data-index-toys-checkbox]');
        card.classList.toggle('index-toys-card--checked', Boolean(cb && cb.checked));
    }

    function syncAllCheckedBorders(root) {
        root.querySelectorAll('.product-card-wrapper--index-toys').forEach(function (card) {
            syncCheckedBorder(card);
        });
    }

    function getSelectedPriceCents(card) {
        var sel = card.querySelector('[data-index-toys-variant-select]');
        if (!sel) return 0;

        // 检查是否是自定义下拉选择器
        if (sel.classList.contains('index-toys-custom-select')) {
            var variantId = sel.getAttribute('data-variant-id');
            var selectedOption = sel.querySelector('.index-toys-select-option[data-value="' + variantId + '"]');
            if (!selectedOption || selectedOption.hasAttribute('disabled')) return 0;
            return parseInt(selectedOption.getAttribute('data-price') || '0', 10) || 0;
        }

        // 原生 select
        var opt = sel.options[sel.selectedIndex];
        if (!opt || opt.disabled) return 0;
        return parseInt(opt.getAttribute('data-price') || '0', 10) || 0;
    }

    function updateTotal(root) {
        var totalEl = root.querySelector('.index-toys-total-amount');
        var sum = 0;
        root.querySelectorAll('[data-index-toys-checkbox]').forEach(function (cb) {
            if (!cb.checked) return;
            var card = getCardWrapper(cb);
            if (card) sum += getSelectedPriceCents(card);
        });
        console.log('index-toys-bundle: Total sum:', sum, 'currency:', root.dataset.currency, 'symbol:', root.dataset.currencySymbol);
        if (totalEl) {
            totalEl.textContent =
                sum > 0 ? formatMoney(sum, root.dataset.currency, root.dataset.currencySymbol) : '—';
        }
    }

    function addToCartVariant(variantId, cart) {
        console.log('addToCartVariant called with variantId:', variantId, 'type:', typeof variantId);
        console.log('theme.routes:', theme.routes);
        var cartAddUrl = theme.routes ? theme.routes.cartAdd : '/cart/add.js';
        console.log('cartAddUrl:', cartAddUrl);

        // 使用 application/x-www-form-urlencoded 格式，而不是 FormData
        var data = 'id=' + encodeURIComponent(variantId) + '&quantity=1';
        console.log('Request data:', data);

        var isCartPage = document.body.getAttribute('data-template') === 'cart';
        if (cart && !isCartPage && typeof cart.getSectionsToRender === 'function') {
            var sections = cart.getSectionsToRender().map(function (section) {
                return section.id;
            }).join(',');
            data += '&sections=' + encodeURIComponent(sections);
            data += '&sections_url=' + encodeURIComponent(window.location.pathname);
        }

        var config = {
            method: 'POST',
            body: data,
            credentials: 'same-origin',
            headers: {
                'Content-Type': 'application/x-www-form-urlencoded',
                'X-Requested-With': 'XMLHttpRequest'
            }
        };

        console.log('Fetch config:', config);
        console.log('Fetch URL:', cartAddUrl);

        return fetch(cartAddUrl, config).then(function (response) {
            console.log('Cart add response status:', response.status);
            if (!response.ok) {
                console.log('Response not OK, status:', response.status);
                return response.json().then(function (errorData) {
                    console.log('Error response data:', errorData);
                    throw new Error('Cart add failed: ' + response.status);
                });
            }
            return response.json();
        }).then(function (data) {
            console.log('Cart add success data:', data);
            return data;
        }).catch(function (error) {
            console.log('Cart add error:', error);
            throw error;
        });
    }

    function showError(msg) {
        if (window.Shopline && window.Shopline.utils && window.Shopline.utils.toast) {
            window.Shopline.utils.toast.open({ duration: 2500, content: msg });
        } else if (window.theme && window.theme.strings) {
            alert(msg);
        } else {
            alert(msg);
        }
    }

    function initCustomSelects(root) {
        console.log('Initializing custom selects in root...');
        var customSelects = root.querySelectorAll('.index-toys-custom-select');
        console.log('Found custom selects:', customSelects.length);

        customSelects.forEach(function(select, index) {
            console.log('Initializing select #' + index);
            var trigger = select.querySelector('.index-toys-select-trigger');
            var options = select.querySelector('.index-toys-select-options');
            var selectedText = select.querySelector('.index-toys-selected-text');
            var selectOptions = select.querySelectorAll('.index-toys-select-option');

            console.log('Trigger:', !!trigger, 'Options:', !!options, 'SelectedText:', !!selectedText, 'SelectOptions:', selectOptions.length);

            if (!trigger || !options || !selectedText) {
                console.error('Missing elements for custom select #' + index);
                return;
            }

            // 点击触发器展开/收起下拉框
            trigger.addEventListener('click', function(e) {
                console.log('Trigger clicked');
                e.stopPropagation();
                e.preventDefault();

                if (options.style.display === 'block') {
                    options.style.display = 'none';
                    return;
                }

                // 使用 absolute 定位，不需要计算位置
                options.style.display = 'block';
                console.log('Options displayed');
            });
          

            // 点击选项
            selectOptions.forEach(function(option) {
                if (option.hasAttribute('disabled')) return;

                option.addEventListener('click', function(e) {
                    console.log('Option clicked:', option.textContent);
                    e.stopPropagation();
                    e.preventDefault();

                    // 更新选中状态
                    selectOptions.forEach(function(opt) {
                        opt.classList.remove('selected');
                    });
                    option.classList.add('selected');

                    // 更新显示文本
                    selectedText.textContent = option.textContent;

                    // 更新 data-variant-id
                    select.setAttribute('data-variant-id', option.getAttribute('data-value'));

                    // 收起下拉框
                    options.style.display = 'none';

                    // 触发 change 事件
                    var changeEvent = new Event('change', { bubbles: true });
                    select.dispatchEvent(changeEvent);
                });
            });

            // 点击外部收起下拉框
            document.addEventListener('click', function(e) {
                if (!select.contains(e.target)) {
                    options.style.display = 'none';
                }
            });

            // 滚动时收起下拉框（只在页面滚动时，不在下拉框内部滚动时）
            window.addEventListener('scroll', function(e) {
                // 如果滚动事件来自下拉框内部，不收起
                if (options.contains(e.target)) {
                    return;
                }
                options.style.display = 'none';
            }, true);
          
        });
    }

    function initSwiper(root) {
        var swiperContainer = root.querySelector('.new-product-list');
        if (!swiperContainer) return;

        // 检查是否已经初始化过
        if (swiperContainer.classList.contains('swiper-initialized')) {
            console.log('index-toys-bundle: Swiper already initialized');
            return;
        }

        // 获取 swiper 的唯一标识
        var swiperId = swiperContainer.getAttribute('data-swiper-product');
        console.log('index-toys-bundle: Initializing swiper:', swiperId);

        // 初始化 Swiper
        if (typeof Swiper !== 'undefined') {
            var swiper = new Swiper('.' + swiperId, {
                slidesPerView: 2,
                spaceBetween: 10,
                navigation: {
                    nextEl: '.new-swiper-button-next',
                    prevEl: '.new-swiper-button-prev',
                },
                breakpoints: {
                    768: {
                        slidesPerView: 3,
                        spaceBetween: 20,
                    },
                },
                on: {
                    init: function() {
                        console.log('index-toys-bundle: Swiper initialized successfully');
                        swiperContainer.classList.add('swiper-initialized');
                    }
                }
            });
        } else {
            console.warn('index-toys-bundle: Swiper library not loaded');
        }
    }

    function init() {
        var roots = document.querySelectorAll('[data-index-toys-root]');
        console.log('index-toys-bundle: Found roots:', roots.length);
        if (!roots.length) return;

        roots.forEach(function (root) {
            // 防止在弹窗中初始化 index-toy 事件
            if (root.closest('.quick-add-modal__content') || root.closest('.modal__inner')|| root.closest('#lf-quick-add-modal-content')) {
                console.log('index-toys-bundle: Skipping root in modal');
                return;
            }

            console.log('index-toys-bundle: Initializing root:', root);
            initIndexToys(root);
        });
    }

    function initIndexToys(root) {
        // 添加移动端自动滚动停止功能
        var autoplayStopInitialized = false; // 防止重复初始化

        // 初始化自定义下拉选择器
        initCustomSelects(root);

        // 初始化 Swiper
        initSwiper(root);

        root.addEventListener('change', function (e) {
            var t = e.target;
            if (t.hasAttribute && t.hasAttribute('data-index-toys-variant-select')) {
                var card = t.closest('.product-card-wrapper--index-toys');
                var cb = card && card.querySelector('[data-index-toys-checkbox]');
                if (cb) cb.checked = true;
            }
            if (
                (t.classList && t.classList.contains('index-toys-card-checkbox')) ||
                (t.hasAttribute && t.hasAttribute('data-index-toys-variant-select'))
            ) {
                var card =
                    t.closest &&
                    t.closest('.product-card-wrapper--index-toys');
                if (card) syncCheckedBorder(card);
                updateTotal(root);
            }
        });

        // 添加 checkbox 点击事件监听（确保点击事件正确触发）
        root.addEventListener('click', function (e) {
            var t = e.target;
            if (t.classList && t.classList.contains('index-toys-card-checkbox')) {
                var card = t.closest('.product-card-wrapper--index-toys');
                if (card) {
                    syncCheckedBorder(card);
                    updateTotal(root);
                }
            }
        });

        var addBtn = root.querySelector('.index-toys-add-checked');
        console.log('index-toys-bundle: Add button found:', !!addBtn);
        if (addBtn) {
            addBtn.addEventListener('click', function () {
                console.log('index-toys-bundle: Add to cart button clicked');
                var cart = document.querySelector('cart-drawer-entry');
                var checked = Array.prototype.slice.call(root.querySelectorAll('[data-index-toys-checkbox]:checked'));
                console.log('index-toys-bundle: Checked items:', checked.length);
                if (!checked.length) {
                    showError('Please select the products first.');
                    return;
                }

                addBtn.disabled = true;
                addBtn.style.opacity = '0.7';
                addBtn.style.pointerEvents = 'none';
                var lastResponse = null;
                var chain = Promise.resolve();

                checked.forEach(function (cb) {
                    chain = chain.then(function () {
                        var card = getCardWrapper(cb);
                        if (!card) {
                            console.log('No card found for checkbox:', cb);
                            return null;
                        }
                        var sel = card.querySelector('[data-index-toys-variant-select]');
                        if (!sel) {
                            console.log('No variant select found in card:', card);
                            return null;
                        }

                        var variantId;
                        // 检查是否是自定义下拉选择器
                        if (sel.classList.contains('index-toys-custom-select')) {
                            variantId = sel.getAttribute('data-variant-id');
                            var selectedOption = sel.querySelector('.index-toys-select-option[data-value="' + variantId + '"]');
                            console.log('Selected custom option details:', {
                                variantId: variantId,
                                text: selectedOption ? selectedOption.textContent : '',
                                disabled: selectedOption ? selectedOption.hasAttribute('disabled') : true
                            });
                            if (!selectedOption || selectedOption.hasAttribute('disabled')) {
                                console.log('Invalid custom option:', selectedOption);
                                return null;
                            }
                        } else {
                            // 原生 select
                            var opt = sel.options[sel.selectedIndex];
                            console.log('Selected option details:', {
                                selectedIndex: sel.selectedIndex,
                                option: opt,
                                value: opt.value,
                                text: opt.text,
                                disabled: opt.disabled,
                                dataset: opt.dataset
                            });
                            if (!opt || opt.disabled) {
                                console.log('Invalid option:', opt);
                                return null;
                            }
                            variantId = opt.value;
                        }

                        console.log('Adding to cart - variant ID:', variantId);
                        if (!variantId || variantId.trim() === '') {
                            console.log('Invalid variant ID:', variantId);
                            return null;
                        }
                        return addToCartVariant(variantId, cart);
                    })
                        .then(function (response) {
                            if (response) {
                                lastResponse = response;
                            }
                        });
                });

                chain
                    .then(function () {
                        var isCartPage = document.body.getAttribute('data-template') === 'cart';
                        if (!lastResponse) return;
                        // 触发 ajaxProduct:added 事件，让 CartDrawer 自动刷新内容并打开抽屉
                        document.dispatchEvent(new CustomEvent('ajaxProduct:added', {
                            detail: {
                                product: lastResponse
                            }
                        }));
                    })
                    .catch(function () { })
                    .finally(function () {
                        addBtn.disabled = false;
                        addBtn.style.opacity = '1';
                        addBtn.style.pointerEvents = 'auto';
                    });
            });
        }

        syncAllCheckedBorders(root);
        updateTotal(root);
   
    }

    // 添加 MutationObserver 来监控动态内容
    function setupMutationObserver() {
        var observer = new MutationObserver(function (mutations) {
            mutations.forEach(function (mutation) {
                if (mutation.type === 'childList') {
                    mutation.addedNodes.forEach(function (node) {
                        if (node.nodeType === Node.ELEMENT_NODE) {
                            // 检查新添加的节点是否包含 index-toy
                            var indexToysElements = node.querySelectorAll ?
                                node.querySelectorAll('[data-index-toys-root]') : [];

                            indexToysElements.forEach(function (root) {
                                // 如果在弹窗中，移除 data-index-toys-root 属性防止初始化
                                if (root.closest('.quick-add-modal__content') || root.closest('.modal__inner')|| root.closest('#lf-quick-add-modal-content')) {
                                    console.log('Preventing index-toy initialization in modal');
                                    root.removeAttribute('data-index-toys-root');
                                }
                            });
                        }
                    });
                }
            });
        });

        // 只监控必要的区域，避免干扰header-layout
        var targetNode = document.querySelector('.main-content') || document.body;
        observer.observe(targetNode, {
            childList: true,
            subtree: true
        });

        console.log('index-toys-bundle: MutationObserver setup completed on:', targetNode);
    }

    if (document.readyState === 'loading') {
        document.addEventListener('DOMContentLoaded', function () {
            init();
            setupMutationObserver();
        });
    } else {
        init();
        setupMutationObserver();
    }
})();
// ========== 【QuickShop 弹窗移动功能（SES兼容版）】 ==========
// (function attachQuickShopMoveHandler() {
//   // 用立即执行函数保证在SES执行前绑定
//   const handler = function(e) {
//     if (window.innerWidth <= 9768) {
//       return;
//     }
//     // 点击 Quick view
//     const quickBtn = e.target.closest('.quick-product__btn');
//     if (quickBtn) {
//       const match = quickBtn.className.match(/js-modal-open-quick-modal-(\d+)/);
//       if (!match) return;
//       const pid = match[1];
//       const modal = document.getElementById('QuickShopModal-' + pid);
//       if (!modal) return;

//       modal._originalParent = modal.parentElement;
//       document.body.appendChild(modal);
//             modal.style.opacity='1';

//       // 强制激活modal（补Shopify原有逻辑）
//       modal.classList.add('modal--is-active');
//       return;
//     }

//     // 点击关闭
//     const closeBtn = e.target.closest('.modal__close');
//     if (closeBtn) {
//       const modal = closeBtn.closest('.modal--quick-shop');
//       if (!modal || !modal._originalParent) return;
//       modal.style.opacity='0';
//       modal._originalParent.appendChild(modal);
//       delete modal._originalParent;
//       modal.classList.remove('modal--is-active');
//     }
//   };

//   // 关键：用 capture:true 绕过SES冒泡拦截
//   document.addEventListener('click', handler, true);
//   console.log('✅ QuickShop移动监听已挂载（SES兼容）');
// })();